<template>
    <Button
        @click="isOpen = true"
        size="small"
        color="light"
        iconName="gears"
    >
        Settings
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
    >
        <template #title> Integration Settings </template>
        <template #content>
            <div class="space-y-2">
                <ApiForm
                    method="POST"
                    :url="
                        urlFactory.makeIntegrationUpdateGoogleCalendarSettingsUrl(
                            integration.id,
                        )
                    "
                    ref="apiFormRef"
                >
                    <FormControl label="Double booking prevention">
                        <CheckboxInput
                            :name="
                                RequestBodyKeyEnum.App_Integration_GoogleCalendar_ShouldCheckGoogleCalendarForConflicts
                            "
                            label="Check Google Calendar for conflicts before booking a meeting"
                            :checked="
                                integration.getGoogleCalendarIntegrationSettings()
                                    .data
                                    .shouldCheckExternalCalendarForConflicts
                            "
                        />
                    </FormControl>
                </ApiForm>
            </div>
        </template>
        <template #actions>
            <Button
                @click="submit()"
                :loading="apiFormRef?.loading.valueOf()"
                iconName="save"
            >
                Save
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import type ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import Integration from '@/App/Integration/Entity/Integration'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const emits = defineEmits<{
        onSuccess: [{ integration: Integration }]
    }>()

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const isOpen = ref<boolean>(false)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            emits('onSuccess', {
                integration: response.getHydratedIntegration(
                    ResponseJsonKeyEnum.App_Integration_UpdateSettings_IntegrationData,
                ),
            })

            isOpen.value = false
        })
    }
    const urlFactory = new UrlFactory()
</script>
